// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const addScatterPlotSecurities = createAction('[Scatter Plot] Add Scatter Plot Securities', props());
export const removeScatterPlotSecurity = createAction('[Scatter Plot] Remove Scatter Plot Security', props());
export const setScatterPlotSecurities = createAction('[Scatter Plot] Set Scatter Plot Securities', props());
export const toggleScatterPlotSecurity = createAction('[Scatter Plot] Toggle Scatter Plot Security', props());
export const updateScatterPlotSecurityOrdering = createAction('[Scatter Plot] Update Scatter Plot Security Ordering', props());
